import { useDispatch } from 'react-redux';
import passwordDialogSlice from './passwordDialogSlice.ts';
import { useCallback } from 'react';

export default function usePasswordDialog() {
  const dispatch = useDispatch();

  const openDialog = useCallback(
    (onConfirm: (input: string) => void) => {
      dispatch(passwordDialogSlice.actions.open(onConfirm));
    },
    [dispatch],
  );

  const closeDialog = useCallback(() => {
    dispatch(passwordDialogSlice.actions.close());
  }, [dispatch]);

  return { openDialog, closeDialog };
}
